import React from 'react';
import { Form, InputGroup, Button, Dropdown, Badge } from 'react-bootstrap';
import { IoSearch, IoClose } from 'react-icons/io5';

const SearchAndFilter = ({
  searchTerm = '',
  selectedType = 'ALL',
  selectedStatus = 'ALL',
  onSearchChange = () => {},
  onSearchSubmit = () => {},
  onTypeChange = () => {},
  onStatusChange = () => {},
  onClearFilters = () => {},
}) => {
  
  const typeOptions = [
    { value: 'ALL', label: 'Semua Tipe' },
    { value: 'Full Time', label: 'Full Time' },
    { value: 'Part Time', label: 'Part Time' },
    { value: 'Contract', label: 'Contract' },
    { value: 'Internship', label: 'Internship' },
  ];

  const statusOptions = [
    { value: 'ALL', label: 'Semua Status' },
    { value: 'OPEN', label: 'Open' },
    { value: 'CLOSED', label: 'Closed' },
  ];

  const isFilterActive = selectedType !== 'ALL' || selectedStatus !== 'ALL';

  return (
    <div className="row g-3 mb-4">
      {/* Search Bar */}
      <div className="col-lg-6">
        <Form onSubmit={(e) => { e.preventDefault(); onSearchSubmit(searchTerm); }}>
          <InputGroup>
            <InputGroup.Text className="bg-white border-end-0">
              <IoSearch className="text-muted" />
            </InputGroup.Text>
            <Form.Control
              placeholder="Cari lowongan pekerjaan..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="border-start-0 shadow-none"
            />
            <Button variant="primary" type="submit">Cari</Button>
          </InputGroup>
        </Form>
      </div>

      {/* Dropdown Tipe */}
      <div className="col-sm-6 col-lg-3">
        <Dropdown className="w-100">
          <Dropdown.Toggle variant="outline-secondary" className="w-100 d-flex justify-content-between align-items-center">
            {typeOptions.find(opt => opt.value === selectedType)?.label}
          </Dropdown.Toggle>
          <Dropdown.Menu className="w-100">
            {typeOptions.map(opt => (
              <Dropdown.Item key={opt.value} active={selectedType === opt.value} onClick={() => onTypeChange(opt.value)}>
                {opt.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Dropdown Status */}
      <div className="col-sm-6 col-lg-3">
        <Dropdown className="w-100">
          <Dropdown.Toggle variant="outline-secondary" className="w-100 d-flex justify-content-between align-items-center">
            {statusOptions.find(opt => opt.value === selectedStatus)?.label}
          </Dropdown.Toggle>
          <Dropdown.Menu className="w-100">
            {statusOptions.map(opt => (
              <Dropdown.Item key={opt.value} active={selectedStatus === opt.value} onClick={() => onStatusChange(opt.value)}>
                {opt.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Active Filter Badges */}
      {isFilterActive && (
        <div className="col-12 mt-2">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <small className="text-muted">Filter aktif:</small>
            {selectedType !== 'ALL' && (
              <Badge bg="primary" className="d-flex align-items-center gap-1 py-2 px-3 rounded-pill">
                Tipe: {selectedType}
                <IoClose style={{ cursor: 'pointer' }} onClick={() => onTypeChange('ALL')} />
              </Badge>
            )}
            {selectedStatus !== 'ALL' && (
              <Badge bg="primary" className="d-flex align-items-center gap-1 py-2 px-3 rounded-pill">
                Status: {selectedStatus}
                <IoClose style={{ cursor: 'pointer' }} onClick={() => onStatusChange('ALL')} />
              </Badge>
            )}
            <Button variant="link" size="sm" className="p-0 text-decoration-none" onClick={onClearFilters}>
              Hapus Semua
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchAndFilter;